import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import {
  Position,
  Wrapper,
  Word,
  Image,
} from './style';

import InstagramEmbed from '../InstagramEmbed';

import AppState from '../../states/AppState';
import IntroCloudState from '../../states/IntroCloudState';
import { ZoomedImage } from '../EditorialListItem/style';

class IntroCloudItem extends Component {
  constructor(props) {
    super(props);

    this.mobxState = observable({
      item: props.item,
      hovered: false,
      z: Math.random(),

      get isInactive() {
        let isInactive = IntroCloudState.resultsAreFiltered;
        if (IntroCloudState.resultsAreFiltered) {
          if (this.item.month) {
            if (IntroCloudState.activeFilterOptionsMonth.indexOf(this.item.month) !== -1) isInactive = false;
          }
          if (this.item.trend) {
            this.item.trend.forEach(trend => {
              if (IntroCloudState.activeFilterOptionsTrend.indexOf(trend) !== -1) isInactive = false;          
            });
          }
        } else if (IntroCloudState.activeItem) {
          isInactive = !(IntroCloudState.activeItemIndex === props.itemIndex);
        }
        return isInactive;
      },

      get isActive() {
        return IntroCloudState.resultsAreFiltered && !this.isInactive;
      },

      get isSlideshowActive() {
        return IntroCloudState.activeItemIndex === props.itemIndex;
      },

      get opacity() {
        // return this.isInactive ? 0.3 : this.hovered ? 1 : (this.z * (1 - 0.5)) + 0.5;
        return this.isInactive ? 0.3 : 1;
      },
    });
  }

  componentDidMount() {
    IntroCloudState.setItemPosition(this.props.itemIndex);
  }

  componentWillReceiveProps(newProps) {
    if (!this.props.twinkling && newProps.twinkling) {
      setTimeout(() => {
        IntroCloudState.twinkleItem(this.props.itemIndex);
      }, 8000);
    }
  }

  imageDimensions() {
    const { item } = this.props;

    if (!item.image) return null;

    const { thumbnailArea } = IntroCloudState;
    const imageWidth = item.image.full.width;
    const imageHeight = item.image.full.height;
    const relativeSize = Math.sqrt(thumbnailArea / (imageWidth * imageHeight));

    let height = imageHeight * relativeSize;
    let width = imageWidth * relativeSize;
    let margin = `-${height / 2}px -${width / 2}px`;
    let backgroundImage = `url('${item.image.full.url}')`;

    return { backgroundImage, height, margin, width };    
  }

  render() {
    const { item, itemIndex } = this.props;
    const { hovered, isInactive, isActive, isSlideshowActive } = this.mobxState;
    let className = `${item.type} ${item.position.z}`;
    
    if (isSlideshowActive) {
      className += ' zoomed';
    } else {
      className += hovered ? ' hovered' : '';      
      className += item.twinkling ? ' inactive twinkling' : (IntroCloudState.introActive || isInactive) ? ' inactive' : isActive ? ' active' : '';      
    }

    return (
      <Position
        className={className}
        style={{
          left: item.position.x,
          top: item.position.y,
        }}
      >
        <Wrapper
          onClick={evt => {
            evt.preventDefault();
            if (AppState.regularMode) IntroCloudState.activateItem(itemIndex);
          }}
          onMouseMove={AppState.regularMode ? () => {
            this.mobxState.hovered = true;
            IntroCloudState.helperText = "Zoom";
          } : null}
          onMouseLeave={AppState.regularMode ? () => {
            this.mobxState.hovered = false;
            IntroCloudState.helperText = "Zoom";
          } : null}
        >
          {item.image && (
            <Image
              style={this.imageDimensions()}
            />
          )}
        </Wrapper>
      </Position>
    );
  }
}

export default observer(IntroCloudItem);



// WEBPACK FOOTER //
// ./src/components/IntroCloudItem/index.js